<template>
  <el-container style="height: 100vh;">
    <!-- 侧边栏 -->
    <el-aside width="200px" style="background-color: #4A5568; height: 100%;">
      <!-- Logo 和公司名区域 -->
      <div class="sidebar-logo" style="height: 60px; display: flex; align-items: center; justify-content: center; background-color: rgba(0,0,0,0.2); border-bottom: 1px solid rgba(255,255,255,0.1);">
        <div style="display: flex; align-items: center;">
          <img src="../assets/logo.png" alt="Logo" style="max-height: 30px; margin-right: 10px;">
          <div style="color: white; font-size: 14px; font-weight: bold;">闪避高手游戏</div>
        </div>
      </div>
      
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        background-color="#4A5568"
        text-color="#fff"
        active-text-color="#ffd04b"
        router
        style="border: none;"
      >
        <el-menu-item index="/data-dashboard">
          <i class="el-icon-data-line"></i>
          <span slot="title">数据大屏</span>
        </el-menu-item>

        <el-menu-item index="/ad-revenue">
          <i class="el-icon-data-analysis"></i>
          <span slot="title">广告收入</span>
        </el-menu-item>

        <el-menu-item v-if="showSystemConfig" index="/system/config">
          <i class="el-icon-setting"></i>
          <span slot="title">系统配置</span>
        </el-menu-item>
        
        <!-- <el-menu-item v-if="showIpBlacklist" index="/ip-blacklist">
          <i class="el-icon-lock"></i>
          <span slot="title">IP封控</span>
        </el-menu-item>
         -->
        <!-- <el-menu-item index="/user-management">
          <i class="el-icon-user-solid"></i>
          <span slot="title">用户管理</span>
        </el-menu-item> -->
<!--         
        <el-menu-item v-if="showDistributionAccount" index="/distribution-account">
          <i class="el-icon-wallet"></i>
          <span slot="title">分销账户</span>
        </el-menu-item>
         -->
        <!-- <el-menu-item index="/user-withdrawal">
          <i class="el-icon-money"></i>
          <span slot="title">用户提现</span>
        </el-menu-item> -->
      </el-menu>
    </el-aside>

    <!-- 右侧容器，包含头部和主体 -->
    <el-container>
      <!-- 顶部标签页 -->
      <el-header style="background-color: white; padding: 0; display: flex; align-items: center; justify-content: space-between; color: #333; box-shadow: 0 1px 4px rgba(0,21,41,.08); height: 60px; border-bottom: 1px solid #d8dce5;">
        <div class="header-title" style="color: #333; font-size: 18px; font-weight: bold; display: flex; align-items: center; height: 100%; padding-left: 20px;">
          <i class="el-icon-star-on" style="margin-right: 8px; color: #409EFF;"></i>
          <p>欢迎使用</p>
        </div>
        
        <!-- 用户信息区域 -->
        <div class="user-info" style="display: flex; align-items: center; padding-right: 20px;">
          <el-dropdown @command="handleUserCommand">
            <span class="el-dropdown-link" style="color: #4A5568; cursor: pointer;">
              <i class="el-icon-user" style="margin-right: 5px;"></i>
              {{ username || '用户' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人资料</el-dropdown-item>
              <el-dropdown-item command="settings">设置</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 主体区域 -->
      <el-main style="padding: 20px; background-color: #f0f2f5;">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'MainLayout',
  data() {
    return {
      username: localStorage.getItem('username') || ''
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    },
    role() {
      // 获取本地存储的role，默认为0
      return parseInt(localStorage.getItem('role')) || 0;
    },
    showSystemConfig() {
      // 当role为0时显示系统配置，否则不显示
      return this.role === 0;
    },
    showIpBlacklist() {
      // 当role为0时显示IP封控，否则不显示
      return this.role === 0;
    },
    showDistributionAccount() {
      // 当role为0时显示分销账户，否则不显示
      return this.role === 0;
    }
  },
  methods: {
    handleMenuSelect(key) {
      // 避免重复导航到当前路由
      if (this.$route.path !== key) {
        this.$router.push(key).catch(err => {
          // 忽略重复导航错误
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    handleUserCommand(command) {
      switch(command) {
        case 'logout':
          // 清除本地存储的token
          localStorage.removeItem('token');
          // 跳转到登录页面
          this.$router.push('/login');
          break;
        case 'profile':
          // 个人资料逻辑
          this.$message.info('个人资料功能待实现');
          break;
        case 'settings':
          // 设置逻辑
          this.$message.info('设置功能待实现');
          break;
      }
    }
  }
}
</script>

<style>
/* 菜单相关样式 */
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.sidebar-logo img {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

/* 响应式处理 */
@media (max-width: 768px) {
  .el-aside {
    width: 64px !important;
  }
}
</style>